import classNames from 'classnames';
import { BillingInformation } from 'queries';
import { Country } from './Country';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  address: {
    ...theme.fonts.body,
    fontStyle: 'normal',
    color: theme.colors.inkPrimary,

    backgroundColor: theme.colors.grayBackground,
    borderRadius: theme.borderRadius.std,
    padding: theme.marginBase * 2,
  },
}));

interface Props {
  billingInfo: BillingInformation;
  className?: string;
}

export const BillingInfoText = ({ billingInfo, className }: Props) => {
  const classes = useStyles();
  return (
    <address className={classNames(classes.address, className)}>
      {billingInfo.billingOrganization} - {billingInfo.email}
      <br />
      {billingInfo.billingAddress && (
        <>
          {billingInfo.billingAddress.line1}
          <br />
          {billingInfo.billingAddress.line2 && (
            <>
              {billingInfo.billingAddress.line2}
              <br />
            </>
          )}
          {billingInfo.billingAddress.postalCode}{' '}
          {billingInfo.billingAddress.city}
          <br />
          <Country countryKey={billingInfo.billingAddress.country} />
          {billingInfo.vatNumber}
        </>
      )}
    </address>
  );
};
